  let aqstsessionId = null; 
  let aqstemisessions = null; 
  let aqstemicardno = null; 
  /*document.addEventListener('DOMContentLoaded', function() {
    var btn = document.getElementById('validate_aqsati_no');
    if (!btn) return;

    btn.addEventListener('click', function(e) {
      e.preventDefault();

      var cardInput = document.getElementById('aqsati_card_no');
      if (!cardInput) {
        console.error('Cannot find #aqsati_card_no');
        return;
      }

      var cardNo = cardInput.value.trim();
      if (!cardNo) {
        alert('Please enter your Aqsati card number.');
        return;
      }

      btn.disabled = true;

        fetch('https://modexstore.uk/modexstore/api/order/validate.php', {
        method: 'POST',
        mode: 'cors', 
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          action: 'validate',
          aqsati_card_no: cardNo
        })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Network response was not OK');
        console.log("response is:")
        console.log(res.text());
        return res.text();
      })
      .then(function(data) {
        console.log('Validation response:', data);
        // TODO: update the UI based on data.succeeded or data.message
      })
      .catch(function(err) {
        console.error('Validation error:', err);
        // Optionally show an error to the user here
      })
      .finally(function() {
        btn.disabled = false;
      });
    });
  });*/

  document.addEventListener('DOMContentLoaded', function() {
  document.getElementById("otp-fields-div").style.display = "none";
  document.getElementById("buynow_btn").style.display = "none";
  document.getElementById("emi_error").style.display = "none";
  // document.getElementById("processnow_btn").style.display = "none";
   document.getElementById("processnow-fields-div").style.display = "none";
  const btn = document.getElementById('validate_aqsati_no');
  if (!btn) return;

  btn.addEventListener('click', async function(e) {
    e.preventDefault();
    btn.disabled = true;
    document.getElementById("emi_error").style.display = "none";
    const cardInput = document.getElementById('aqsati_card_no');
    if (!cardInput) {
      console.error('Cannot find #aqsati_card_no');
      btn.disabled = false;
      return;
    }

    const cardNo = cardInput.value.trim();
    if (!cardNo) {
      //alert('Please enter your Aqsati card number.');
      showEmiError("Please enter your Aqsati card number.");
      btn.disabled = false;
      return;
    }
    if (cardNo.length !== 16 || !/^\d{16}$/.test(cardNo)) {
      //alert("⚠️ Please enter a valid 6-digit OTP");
      showEmiError("⚠️ Please enter a 16-digit Card Number");
      btn.disabled = false;
      return;
    }

    btn.disabled = true;

    try {
      const cartTotal = await getCartTotal();
      const res = await fetch('https://modexstore.uk/modexstore/api/order/validate.php', {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          action: 'validate',
          aqsati_card_no: cardNo,
          aqsati_car_total: cartTotal
        })
      });

      if (!res.ok) {
        throw new Error(`Server responded with ${res.status}`);
      }

      const text = await res.text(); // read once
      console.log("Raw response text:", text);

      let data;
      try {
        data = JSON.parse(text); // attempt JSON parse
        console.log("Parsed JSON:", data);
        //console.log("Parsed JSON:", data.succeeded);
        //debugger;

        // ✅ Example UI logic
        /*if (data.succeeded) {
          document.getElementById("cardno-fields-div").style.display = "none";
          document.getElementById("otp-fields-div").style.display = "block";
          aqstsessionId = data.data.session.sessionId;
          alert("✅ " + data.message);
        } else {
          alert("❌ " + data.message);
        }*/
       if (data.message=='Success') {
          document.getElementById("cardno-fields-div").style.display = "none";
          document.getElementById("otp-fields-div").style.display = "block";
          //aqstsessionId = data.data.session.sessionId;
          aqstsessionId = data.data.sessionId;
          console.log("aqstsessionId"+aqstsessionId);
          aqstemicardno=cardNo;
          //alert("✅ " + data.message);
        } else {
          alert("❌ " + data.message);
          showEmiError(data.message);
        }

      } catch (err) {
        console.error("Response was not valid JSON");
        //alert("Server returned non-JSON response:\n" + text);
        showEmiError("Server returned non-JSON response:\n" + text);
      }

    } catch (err) {
      console.error("Validation error:", err);
      //alert("Something went wrong: " + err.message);
       showEmiError("Something went wrong: " + err.message);
    } finally {
      btn.disabled = false;
      document.getElementById("emi_error").style.display = "none";
    }
  });
});

 document.getElementById("validate_OTP_btn").addEventListener("click", async function () {
  document.getElementById("emi_error").style.display = "none";
  const otpbtn = document.getElementById('validate_OTP_btn');    
  otpbtn.disabled = true;

  // Collect all OTP input values
  const inputs = document.querySelectorAll("#otp input.otp-field");
  let otpValue = "";
  inputs.forEach(input => {
    otpValue += input.value.trim();
  });

  if (otpValue.length !== 8 || !/^\d{8}$/.test(otpValue)) {
    //alert("⚠️ Please enter a valid 6-digit OTP");
    showEmiError("⚠️ Please enter a valid 8-digit OTP");
    otpbtn.disabled = false;
    return;
  }

  console.log("Collected OTP:", otpValue);
  console.log("aqstsessionId"+aqstsessionId);

  try {
    //let cartItems = await fetchShopifyCart();
    //let customerId = ShopifyAnalytics.meta.page.customerId;
    //console.log(customerId);

    const res = await fetch('https://modexstore.uk/modexstore/api/order/validate.php', { 
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        action: 'verifyotp',
        otp: otpValue,       
        sessionId: aqstsessionId,
        //items:cartItems,
        //customerId:customerId
      })
    });

    if (!res.ok) {
      throw new Error(`Server responded with ${res.status}`);
    }

    const text = await res.text();
    console.log("Raw response text:", text);

    let data;
    try {
      data = JSON.parse(text);
      console.log("Parsed JSON:", data);

      if (data.succeeded) {
        document.getElementById("cardno-fields-div").style.display = "none";
        document.getElementById("otp-fields-div").style.display = "none";
        document.getElementById("processnow-fields-div").style.display = "block";
        //document.getElementById("processnow_btn").style.display = "block";
        document.getElementById("buynow_btn").style.display = "block";
        const { amount, amountPerMonth, countOfMonth, dueDate } = data.data;
        const formattedDate = new Date(dueDate).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric"
        });
         document.getElementById("processnow-data").innerHTML = `
            <p><strong>Total Amount:</strong> ${amount}</p>
            <p><strong>EMI Amount per Month:</strong> ${amountPerMonth}</p>
            <p><strong>Number of Installments/Months:</strong> ${countOfMonth}</p>
            <p><strong>Due Date:</strong> ${formattedDate}</p>
          `;
        
        //alert("✅ " + data.message);
        aqstemisessions=data.datasessions;
      } else {
        //alert("❌ " + data.message);
        showEmiError("Error "+data.message);
      }
    } catch (err) {
      console.error("Response was not valid JSON");
      //alert("Server returned non-JSON response:\n" + text);
      showEmiError("Server returned non-JSON response:\n" + text);
    }

  } catch (err) {
    console.error("Validation error:", err);
    //alert("Something went wrong: " + err.message);
     showEmiError("Something went wrong: " + err.message);
  } finally {
    otpbtn.disabled = false;
    document.getElementById("emi_error").style.display = "none";
  }

  // Example: log OTP
  console.log("Entered OTP:", otpValue);
});


 document.getElementById("buynow_btn").addEventListener("click", async function () {
  const buynow_btn = document.getElementById('buynow_btn');    
  buynow_btn.disabled = true;

  const userConfirmed = confirm("Are you sure you want to proceed with this purchase?");
  if (!userConfirmed) {
    buynow_btn.disabled = false;
    return;
  }

  try {
    //let cartItems = await fetchShopifyCart();
    let response = await fetch("/cart.js");
    let cart = await response.json();
    let cartItems = cart.items;
    const cartTotal = (cart.total_price / 100).toFixed(2);
    console.log("cartTotal"+cartTotal);

    let customerId = ShopifyAnalytics.meta.page.customerId;
    console.log(customerId);
    console.log(window.ShopifyCustomer.id);

    const res = await fetch('https://modexstore.uk/modexstore/api/order/post.php', { 
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        action: 'buynowwithemi',
        //otp: otpValue,       
        sessionId: aqstsessionId,
        items:cartItems,
        cartTotal:cartTotal,
        emi_sessions:aqstemisessions,
        aqstemicardno:aqstemicardno
        //customerId:customerId
      })
    });

    if (!res.ok) {
      throw new Error(`Server responded with ${res.status}`);
    }

    const text = await res.text();
    console.log("Raw response text:", text);

    let data;
    try {
      data = JSON.parse(text);
      console.log("Parsed JSON:", data);
      debugger;

             const currentPath = window.location.href;
             //const locationValue = event.target.getAttribute('location');
              if (data && data.checkout_url) {
              // button.classList.remove("progressing");
                if (currentPath.includes('.com/ar')) {
                  window.location.href = data.checkout_url+"?locale=ar";
                }else{
                  window.location.href = data.checkout_url;
                }
              } else {
                //hideCartSpinner();
                console.error("error-Failed to create draft order.");
                showEmiError("error-Failed to create draft order.");
              }
    } catch (err) {
      console.error("Response was not valid JSON");
      //alert("Server returned non-JSON response:\n" + text);
       showEmiError("error-Failed to create draft order.");
    }

  } catch (err) {
    console.error("Validation error:", err);
    //alert("Something went wrong: " + err.message);
     showEmiError("error-Failed to create draft order.");
  } finally {
    buynow_btn.disabled = false;
    document.getElementById("emi_error").style.display = "none";
  }

  // Example: log OTP
  //console.log("Entered OTP:", otpValue);
});


async function getCartTotal() {
  try {
    const res = await fetch("/cart.js"); // Shopify's AJAX cart endpoint
    const cart = await res.json();
    console.log("Shopify cart:", cart);

    // total_price is in cents → convert to currency
    const cartTotal = (cart.total_price / 100).toFixed(2);
    console.log("Cart Total:", cartTotal);

    return cartTotal;
  } catch (err) {
    console.error("Error fetching cart:", err);
    return 0;
  }
}

async function fetchShopifyCart() {
    try {
        let response = await fetch("/cart.js");
        let data = await response.json();
        return data.items;
    } catch (error) {
        return [];
    }
}

function showEmiError(message) {
    const errorEl = document.getElementById("emi_error");
    errorEl.innerText = '';
    errorEl.innerText = message;
    errorEl.style.display = "block";   // make it visible
}


//default city select code
(function () {
  const cityEl = document.getElementById('city');
  const warningMsg = document.getElementById('city-warning');
  const checkoutBtn = document.querySelector('button[name="checkout"]');
  if (!cityEl) return;

  async function setCartNote(noteText) {
    try {
      // Update Shopify cart note via AJAX API
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: noteText || '' })
      });

      // If your theme shows a <textarea name="note">, keep it in sync
      const noteArea = document.querySelector('textarea[name="note"]');
      if (noteArea) noteArea.value = noteText || '';
    } catch (e) {
      console.error('Failed to set cart note:', e);
    }
  }

  cityEl.addEventListener('change', function () {
    const city = this.value && this.value.trim();
    // Example: set exactly the city name. Change to `City: ${city}` if you need a label.
    setCartNote(" city:"+city || '');
  });

  // Optional: set note on page load if a city is already selected
  if (cityEl.value) setCartNote(cityEl.value.trim());
})();


(function () {
  const cityDropdown = document.getElementById('city');
  const warningMsg = document.getElementById('city-warning');
  const checkoutBtn = document.querySelector('button[name="checkout"]');

  if (!cityDropdown || !checkoutBtn) return;

  // Save city as cart note when changed
  async function setCartNote(noteText) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: noteText })
    });
  }

  cityDropdown.addEventListener('change', async function () {
    const city = this.value.trim();
    warningMsg.style.display = 'none'; // hide warning when selected
    if (city) await setCartNote(" city:"+city || '');
  });

  checkoutBtn.addEventListener('click', function (e) {
    const selectedCity = cityDropdown.value.trim();
    if (!selectedCity) {
      e.preventDefault();
      warningMsg.style.display = 'block';
      cityDropdown.focus();
    }
  });
})();